
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Etwa die Hälfte der Menschen, die sich angesteckt haben, würden das gar nicht merken, sagte kürzlich RKI-Chef Lothar Wieler: «Die sehen wir gar nicht.» `}</p>
    <p>{`Eine Analyse der Infektionen und Erkrankungen auf dem Kreuzfahrtschiff Diamond Princess, auf dem sich etwa 700 der 3711 Passagiere und Crewmitglieder angesteckt hatten, bestätigt den oftmals ungewöhnlichen klinischen Verlauf nach einer Infektion mit Sars-CoV-2. Fast alle Fahrgäste auf dem Schiff wurden ge­testet, manche mehrmals. `}<strong parentName="p">{`Doch obwohl sich vor allem ältere Menschen an Bord befanden und in dieser Gruppe schwere Verläufe häufiger sind, wurden bei 18 Prozent der Infizierten keine Symptome festgestellt`}</strong>{`, wie das Fachmagazin «Nature» berichtet. «Das ist ein erheblicher Anteil», sagt der Epidemiologe Gerardo Chowell von der Universität Atlanta, der an der Studie beteiligt war. Werde die Altersverteilung auf dem Schiff berücksichtigt, könne dies bedeuten, dass der Prozentsatz der Infizierten ohne Symptome in der Allgemeinbevölkerung weitaus höher liege.`}</p>
    <p>{`Eine Analyse bei Japanern, die nach dem Corona-Ausbruch in Wuhan in ihr Land zurückgeholt worden waren, `}<strong parentName="p">{`ergab einen Anteil von 33 Prozent Infizierten, die keine Symptome aufwiesen`}</strong>{`.`}</p>
    <p>{`In Island hat die Biotech-Firma deCODE Genetics mehr als 6000 Tests durchgeführt, allesamt an Freiwilligen, die keine oder kaum Symptome hatten. `}<strong parentName="p">{`Etwa die Hälfte der Infizierten hatte überhaupt keine Symptome, der Rest jene einer sehr milden Erkältung.`}</strong></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;